import { render, staticRenderFns } from "./WorkshopDetails.vue?vue&type=template&id=717f0851&scoped=true"
import script from "./WorkshopDetails.vue?vue&type=script&lang=js"
export * from "./WorkshopDetails.vue?vue&type=script&lang=js"
import style0 from "./WorkshopDetails.vue?vue&type=style&index=0&id=717f0851&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717f0851",
  null
  
)

export default component.exports